import { useEffect, useRef, useCallback } from "react";
import Lenis from "lenis";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Artisti } from "./components/Artisti";
import { Produzioni } from "./components/Produzioni";
import { Manifesto } from "./components/Manifesto";
import { Contatti } from "./components/Contatti";
import { Footer } from "./components/Footer";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const navigate = useCallback((hash) => {
    const el = document.querySelector(hash);
    if (!el) return;
    if (lenisRef.current) {
      lenisRef.current.scrollTo(el, { offset: -72, duration: 1.4 });
    } else {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <div className="grain bg-[#08070B] text-[#F4F1EE] min-h-screen">
      <Navbar onNavigate={navigate} />
      <main>
        <Hero />
        <Marquee />
        <Artisti />
        <Produzioni />
        <Manifesto />
        <Contatti />
      </main>
      <Footer onNavigate={navigate} />
    </div>
  );
}

export default App;
